export default "__VITE_ASSET__Cbzgm8wl__"